import type { ReactNode } from 'react';
import { clsx } from 'clsx';
import { Rail } from './Rail';
import styles from './interior.module.css';

interface ReadingLayoutProps {
  children: ReactNode;
  navigation?: ReactNode;
  className?: string;
}

/** The approved centered reading rail. Navigation precedes content in DOM order. */
export function ReadingLayout({
  children,
  navigation,
  className,
}: ReadingLayoutProps): React.ReactElement {
  return (
    <Rail className={clsx(styles.reading, className)}>
      {navigation}
      {children}
    </Rail>
  );
}
